import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";
import { useTelefonosContext } from "../telefonos-context";

export function TelefonosTable() {
  const navigate = useNavigate();

  const { telefonos, deleteTelefono, verifyTelefono } = useTelefonosContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Números de teléfono</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!telefonos.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Número de teléfono",
                  // "Estado",
                  //  "Opciones"
                ].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {telefonos.map((telefono, index) => (
                <TableRow key={telefono.telefono_id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        {telefono.telefono_numero}
                      </Typography>

                      {!!telefono.telefono_principal && (
                        <Chip
                          label="Principal"
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      )}
                    </Stack>
                  </TableCell>

                  {/* <TableCell>
                    <Chip
                      label={
                        !!telefono.telefono_verificado
                          ? "Verificado"
                          : "Pendiente"
                      }
                      color={
                        !!telefono.telefono_verificado ? "success" : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {!telefono.telefono_verificado ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyTelefono({
                                telefonoId: telefono.telefono_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(`${telefono.telefono_id}/edit`)
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () => {
                              await deleteTelefono({
                                telefonoId: telefono.telefono_id,
                              });
                            }}
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin números de teléfono
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
